import React, { useEffect, useState } from 'react'
import { Outlet, NavLink, useParams, Link } from 'react-router-dom'
import { api } from '../../app/Api/ApiSlice'
import Loader from '../../components/Loader'
import { toast } from 'react-toastify'
import "./storesStyles.css"


//component shows this menu to users, not admins

const ShopMenu = () => {
    const [isLoading, setIsLoading] = useState(true)
    const [storeData, setStoreData] = useState(null)

    const { name } = useParams()

    useEffect(() => {
        getStoreData()
    }, [name])

    const getStoreData = async () => {
        try {
            setIsLoading(true)
            const response = await api.get(`/stores/${name}`)
            // console.log(response)
            if (response && response.status === 200) {
                setIsLoading(false)
                setStoreData(response?.data)
            }
        } catch (error) {
            setIsLoading(false)
            toast.error(error.response?.data.message)
        }
        finally {
            setIsLoading(false)
        }
    }

    return (
        <div className=''>
            {
                !isLoading && storeData === null &&
                <div className='unfound-store page-body'>
                    <p>{`${name} business was not found`}</p>
                    <Link to={"/b"}>
                        <button className='normal-button'>Back</button>
                    </Link>
                </div>
            }
                  {isLoading && <Loader />}
            {
                storeData !== null &&
                <div className="multi-content-page">
                    <div className="page-side-menu">
                        <div className="menu-items-list">
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/`}>{`${name}`}</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/products`}>Products</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/branches`}>Branches</NavLink>
                            </div>
                             <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/carts`}>Carts</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/orders`}>Orders</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/invoices`}>Invoices</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/address`}>Address</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/contacts`}>Contacts</NavLink>
                            </div>
                             <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/admins`}>Admins</NavLink>
                            </div>
                            <div className='page-menu-item'>
                                <NavLink to={`/b/${name}/suggestionbox`}>suggestion box</NavLink>
                            </div>
                            {
                                storeData.isAdmin &&
                                <div className='page-menu-item'>
                                    <NavLink to={`/b/manage/${name}`}>Manage</NavLink>
                                </div>
                            }
                        </div>
                    </div>
                    <div className="store-page-container">
                        <Outlet />
                    </div>
                </div>
            }
        </div>
    )
}

export default ShopMenu